// RF-03 — benefícios por categoria do cliente. Escopo de EMPRESA: o endpoint é
// `/companies/me/tier-benefits` e o back tira o companyId do token, então não há
// storeId em lugar nenhum aqui. A UI vive no SettingsTab (única tela de config que
// o gestor já acessa) com aviso explícito de que vale para a rede toda.
import { api } from '@/lib/api';

export type CustomerTier = 'BRONZE' | 'PRATA' | 'OURO' | 'DIAMANTE';

export interface TierBenefit {
  id: string;
  tier: CustomerTier;
  text: string;
  position: number;
}

export interface CreateTierBenefitInput {
  tier: CustomerTier;
  text: string;
  position?: number;
}

export interface UpdateTierBenefitInput {
  id: string;
  tier?: CustomerTier;
  text?: string;
  position?: number;
}

export const tierBenefitsApi = api.injectEndpoints({
  endpoints: (build) => ({
    listTierBenefits: build.query<TierBenefit[], void>({
      query: () => ({ url: '/companies/me/tier-benefits' }),
      providesTags: [{ type: 'TierBenefit', id: 'LIST' }],
    }),
    createTierBenefit: build.mutation<TierBenefit, CreateTierBenefitInput>({
      query: (body) => ({ url: '/companies/me/tier-benefits', method: 'POST', body }),
      invalidatesTags: [{ type: 'TierBenefit', id: 'LIST' }],
    }),
    updateTierBenefit: build.mutation<TierBenefit, UpdateTierBenefitInput>({
      query: ({ id, ...patch }) => ({
        url: `/companies/me/tier-benefits/${id}`,
        method: 'PATCH',
        body: patch,
      }),
      invalidatesTags: [{ type: 'TierBenefit', id: 'LIST' }],
    }),
    deleteTierBenefit: build.mutation<{ ok: true }, string>({
      query: (id) => ({ url: `/companies/me/tier-benefits/${id}`, method: 'DELETE' }),
      invalidatesTags: [{ type: 'TierBenefit', id: 'LIST' }],
    }),
  }),
});

export const {
  useListTierBenefitsQuery,
  useCreateTierBenefitMutation,
  useUpdateTierBenefitMutation,
  useDeleteTierBenefitMutation,
} = tierBenefitsApi;
